import { graphql } from "../gql";

export const setDocumentationClaimStatesMutationDoc = graphql(`
  mutation setDocumentationClaimStates(
    $input: SetDocumentationClaimStatesInput!
  ) {
    setDocumentationClaimStates(input: $input) {
      documentationClaimStates {
        batchClaim {
          batchClaimStateById {
            claimAuditType
            clientSignOffClaimState
            determinedAdjustedAllowedAmount
            determinedClientSavings
            determinedDiscrepantAmount
            disputedFindingClaimState
            documentationClaimState
            id
            invoiceClaimState
            isProviderActive
            isRealized
            negotiationClaimState
            onHoldClaimState
            potentialAdjustedAllowedAmount
            potentialClientSavings
            potentialDiscrepantAmount
            providerSignOffClaimState
            reported
            workflowClaimState
          }
          id
        }
      }
    }
  }
`);
